import { BLOCKCHAIN_NETWORKS } from '~/common/constants'
import { BANK_TRANSFER_NETWORK } from '~/types'
import { BankNetworkOptions } from '~/types/bank'
import { BlockchainNetworkOptions } from '~/types/blockchain'

export const TRANSFER_STATE_STATUS = {
  IDLE: 'IDLE',
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
} as const

export const BLOCKCHAIN_NETWORK_OPTIONS: BlockchainNetworkOptions = {
  [BLOCKCHAIN_NETWORKS.ETHEREUM]: {
    label: BLOCKCHAIN_NETWORKS.ETHEREUM,
    value: BLOCKCHAIN_NETWORKS.ETHEREUM,
    disabled: false,
    showNewBadge: false,
  },
  [BLOCKCHAIN_NETWORKS.POLYGON]: {
    label: BLOCKCHAIN_NETWORKS.POLYGON,
    value: BLOCKCHAIN_NETWORKS.POLYGON,
    disabled: false,
    showNewBadge: false,
  },
  [BLOCKCHAIN_NETWORKS.AVALANCHE]: {
    label: BLOCKCHAIN_NETWORKS.AVALANCHE,
    value: BLOCKCHAIN_NETWORKS.AVALANCHE,
    disabled: false,
    showNewBadge: false,
  },
  [BLOCKCHAIN_NETWORKS.ARBITRUM]: {
    label: BLOCKCHAIN_NETWORKS.ARBITRUM,
    value: BLOCKCHAIN_NETWORKS.ARBITRUM,
    disabled: false,
    showNewBadge: false,
  },
  [BLOCKCHAIN_NETWORKS.HEDERA]: {
    label: BLOCKCHAIN_NETWORKS.HEDERA,
    value: BLOCKCHAIN_NETWORKS.HEDERA,
    disabled: false,
    showNewBadge: false,
  },
  [BLOCKCHAIN_NETWORKS.BNBSMART]: {
    label: BLOCKCHAIN_NETWORKS.BNBSMART,
    value: BLOCKCHAIN_NETWORKS.BNBSMART,
    disabled: false,
    showNewBadge: false,
  },
  [BLOCKCHAIN_NETWORKS.TRON]: {
    label: BLOCKCHAIN_NETWORKS.TRON,
    value: BLOCKCHAIN_NETWORKS.TRON,
    disabled: false,
    showNewBadge: false,
  },
  [BLOCKCHAIN_NETWORKS.RIPPLE]: {
    label: BLOCKCHAIN_NETWORKS.RIPPLE,
    value: BLOCKCHAIN_NETWORKS.RIPPLE,
    disabled: false,
    showNewBadge: false,
  },
  [BLOCKCHAIN_NETWORKS.ZILLIQA]: {
    label: BLOCKCHAIN_NETWORKS.ZILLIQA,
    value: BLOCKCHAIN_NETWORKS.ZILLIQA,
    disabled: false,
    showNewBadge: false,
  },
  [BLOCKCHAIN_NETWORKS.SOLANA]: {
    label: BLOCKCHAIN_NETWORKS.SOLANA,
    value: BLOCKCHAIN_NETWORKS.SOLANA,
    disabled: false,
    showNewBadge: true,
  },
  [BLOCKCHAIN_NETWORKS.BASE]: {
    label: BLOCKCHAIN_NETWORKS.BASE,
    value: BLOCKCHAIN_NETWORKS.BASE,
    disabled: false,
    showNewBadge: true,
  },
} as const

export const BANK_NETWORK_OPTIONS: BankNetworkOptions = {
  [BANK_TRANSFER_NETWORK.FAST]: {
    label: BANK_TRANSFER_NETWORK.FAST.toUpperCase(),
    value: BANK_TRANSFER_NETWORK.FAST,
  },
  [BANK_TRANSFER_NETWORK.MEPS]: {
    label: BANK_TRANSFER_NETWORK.MEPS.toUpperCase(),
    value: BANK_TRANSFER_NETWORK.MEPS,
  },
  [BANK_TRANSFER_NETWORK.SWIFT]: {
    label: BANK_TRANSFER_NETWORK.SWIFT.toUpperCase(),
    value: BANK_TRANSFER_NETWORK.SWIFT,
  },
} as const
